import axios from "axios";
import { API_BASE_URL } from "../config/config";

// const currentDomain = window.location.hostname; // Örn: "localhost" veya "www.example.com"

// const API_BASE_URL = (currentDomain === 'localhost' || currentDomain === '127.0.0.1' || currentDomain === 'aiconnect.com.tr'  || currentDomain === 'demo.aiconnect.com.tr' )
//   ? 'https://apis.aiconnect.com.tr/dids'
//   : `https://apis.${currentDomain}/dids`;

const DidServices = {
  list: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
    });
    return axios.get(`${API_BASE_URL}/dids/list?${params.toString()}`);
  },
  addnew: (data) => {
    return axios.post(`${API_BASE_URL}/dids/addnew`, data);
  },
  insert: (data) => {
    return axios.post(`${API_BASE_URL}/dids/insert`, data);
  },
  delete: (data) => {
    return axios.post(`${API_BASE_URL}/dids/delete`, data);
  },
  edit: (data) => {
    return axios.post(`${API_BASE_URL}/dids/edit`, data);
  },
  update: (data) => {
    return axios.post(`${API_BASE_URL}/dids/update`, data);
  },
  downloadAll: (data) => {
    const params = new URLSearchParams({
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
    });
    return axios.get(
      `${API_BASE_URL}/dids/reportDownloadAll?${params.toString()}`
    );
  },
};

export default DidServices;
